import { SERVICE_PROCESS_DIRECTION } from "../../props";

export interface ServiceData {
  title: string;
  description: string;
}

export interface ServiceProcessData {
  number: number;
  title: string;
  description: string;
  direction: SERVICE_PROCESS_DIRECTION;
}

export interface ServicesHeadlineData {
  title: string;
  subtitle: string;
}

export interface ProcessHeadlineData {
  title: string;
  subtitle: string;
}

export interface ServicesContent {
  headline: ServicesHeadlineData;
  services: ServiceData[];
  processHeadline: ProcessHeadlineData;
  processSteps: ServiceProcessData[];
}

export const SERVICES_CONTENT: ServicesContent = {
  headline: {
    title: "Services",
    subtitle: "Discover the solutions our team of engineers provide."
  },
  services: [
    {
      title: "Software Development",
      description: "From concept to deployment, we craft high-quality, scalable software tailored to your needs. Whether it's a web app, mobile solution, or complex system, we turn ideas into reality."
    },
    {
      title: "AI Solutions",
      description: "Harness the power of artificial intelligence to automate processes, gain insights, and enhance user experiences. We build smart, data-driven solutions that give businesses a competitive edge."
    },
    {
      title: "Consulting",
      description: "With years of industry experience, we provide expert guidance to help you navigate tech challenges, optimize processes, and make informed decisions that drive growth."
    },
    {
      title: "In-House Products",
      description: "We don't just build for clients—we create our own innovative solutions to solve real-world problems, bringing cutting-edge tech to market."
    },
    {
      title: "Outsourcing",
      description: "Need extra hands? Our skilled team seamlessly integrates with yours, providing expertise and efficiency to help you scale and deliver high-quality software faster."
    },
    {
      title: "Hosting",
      description: "Reliable, secure, and optimized hosting solutions to keep your applications running smoothly, ensuring high performance and uptime."
    }
  ],
  processHeadline: {
    title: "Process",
    subtitle: ""
  },
  processSteps: [
    {
      number: 1,
      title: "Discovery & Planning",
      description: "We start by deeply understanding your vision, goals, and requirements. Through collaborative workshops and detailed analysis, we create a comprehensive roadmap that aligns technology with your business objectives.",
      direction: SERVICE_PROCESS_DIRECTION.LEFT
    },
    {
      number: 2,
      title: "Design & Prototyping",
      description: "Our design phase transforms concepts into tangible prototypes. We focus on user experience, interface design, and technical architecture to create a solid foundation for development while allowing for early feedback and refinement.",
      direction: SERVICE_PROCESS_DIRECTION.RIGHT
    },
    {
      number: 3,
      title: "Development & Implementation",
      description: "Using modern development practices and technologies, our team brings your solution to life. We work in iterative cycles, delivering functional components regularly and adapting to changing requirements with agility and precision.",
      direction: SERVICE_PROCESS_DIRECTION.LEFT
    },
    {
      number: 4,
      title: "Testing & Quality Assurance",
      description: "Quality is non-negotiable. Our rigorous testing methodology ensures your solution is robust, secure, and performs optimally across all intended platforms and use cases before it reaches your users.",
      direction: SERVICE_PROCESS_DIRECTION.RIGHT
    },
    {
      number: 5,
      title: "Deployment & Ongoing Support",
      description: "We ensure smooth deployment and provide comprehensive support after launch. Our team remains available for maintenance, updates, and enhancements as your business evolves and grows.",
      direction: SERVICE_PROCESS_DIRECTION.LEFT
    }
  ]
}; 